$(document).ready(function() {

    var revealClose = $('.reveal[id="newsletter"]').find('.close-button'); // find newsletter reveal

    var readCookie = Cookies.get('firstvisit');
    var newsletterClosed = Cookies.get('newsletterclosed');

    // var readCookie = Cookies.get('firstvisitoffer'); //for when popup is discount image instead
    // var newsletterClosed = Cookies.get('newsletterclosedoffer');

    if (!readCookie || readCookie !== 'no' ) { //If cookie doesnt exist or if its their first visit, 
        if ( newsletterClosed !== '1' ) { //and if they havent closed it
            //popup newsletter now
            setTimeout(function(){
              $('#newsletter').foundation('open');
            }, 5000)
        }

        //changed to create cookie on newsletter submit instead of below...
        // Cookies.set('firstvisit', 'no', { expires: 30 }); //Its their first visit, set value to no so doesnt popup again // expires in 30 days
    }

    revealClose.click(function() {
        Cookies.set('newsletterclosed', "1");  
    });

    //Get email entered and then add it to the email input within the popup
    $('form[name="newsletter-trigger"]').submit(function(e) {
        e.preventDefault();
        var row = $('form[name="newsletter-trigger"]');
        var popupInputEmail = $('form[name="newsletter-signup"]').find('input[name="email_address"]');
        var getInputtedEmail = row.find('input[name="email_address"]').val();
        var popupInputName = $('form[name="newsletter-signup"]').find('input[name="first_name"]');
        var getInputtedName = row.find('input[name="first_name"]').val();

        popupInputEmail.val(getInputtedEmail);
        popupInputName.val(getInputtedName);
        $('#newsletter').foundation('open');
    });

    var $newsletter_form = $('.subscribe-to-newsletter');
    $newsletter_form.validate({
      ignore: '.ignore',
        rules: {
            first_name: {
                required: true
            },
            email_address: {
              required: true,
              email: true,
            }
        },
        submitHandler: function() {
            $newsletter_form.append('<img class="loading" width="20" src="'+$(document.body).data('base') +'/images/site/loading.gif">');

            $.ajax({
              type: "POST",
              url: $(document.body).data('base') +"/ajax/newsletter.php",
              data: $newsletter_form.serialize(),
              success: function(response) {
                  var $response = JSON.parse(response);
                  $newsletter_form.find('.loading').remove();

                  if (typeof $response === 'object' && $response !== null && $response['status'] !== 'success') {
                      swal({
                        html: true,
                        title: $response['title'], 
                        text: $response['message'], 
                        type: $response['status']
                      });
                  }
                  if (typeof $response === 'object' && $response !== null && $response['status'] == 'success') { 
                    $('#newsletter').foundation('close');
                    swal({
                      html: true,
                      title: $response['title'], 
                      text: $response['message'], 
                      type: $response['status']
                    });
                    ga('send', 'pageview', '/newsletter-signup');
                    gtag("event", "newsletter_signup");
                    Cookies.set('firstvisit', 'no', { expires: 30 }); //Already submitted, set value to no so doesnt popup again // expires in 30 days
                  } else {
                      newsletter_form.find('input').remove();
                      newsletter_form.append('<div data-alert class="alert-box ' + $response['status'] + ' radius">' + $response['message'] + '</div>');
                  }
              }
            });

            return false;
        }
    });

});